import React from 'react';

import HeroImageBlock from './styles/HeroImageBlock';
import HeroWrapper from './styles/HeroWrapper';
import HeadingWrapper from './styles/HeadingWrapper';
import HeadingTypography from './styles/HeadingTypography';
import HeroImageWrapper from './styles/HeroImageWrapper';

function HeroSection() {
  return (
    <HeroWrapper>
      <HeroImageWrapper>
        <HeroImageBlock
          srcSet={{
            xl: 'pj-man-in-denim-jacket/pj-man-in-denim-jacket@xl.jpg',
            md: 'pj-man-in-denim-jacket/pj-man-in-denim-jacket@md.jpg',
            xs: 'pj-man-in-denim-jacket/pj-man-in-denim-jacket@xs.jpg',
          }}
          altIntlKey="BUSINESS_ACCOUNT.HERO.IMAGE_ALT"
        />
      </HeroImageWrapper>
      <HeadingWrapper>
        <HeadingTypography
          variant="subtitle"
          tag="h1"
          intlKey="cms.businessAccountPage.heroSubtitle"
        />
        <HeadingTypography
          variant="supertitle"
          tag="h2"
          intlKey="cms.businessAccountPage.heroTitle"
        />
      </HeadingWrapper>
    </HeroWrapper>
  );
}

export default React.memo(HeroSection);
